import { Dispatch } from 'redux';
import { updateLoanAppByID, getLoanAppplication } from 'src/services/loans';
import { ThunkActionCreator } from 'src/store/types';
import {
  loanApplicationRequest,
  loanApplicationRequestStart,
  loanApplicationRequestSuccess,
  loanApplicationRequestSuccessById,
  loanApplicationRequestFailById,
  setLoanAppInStore
} from './loanapp.actions';
import { lensPath, pathOr, set } from 'ramda';

export const requestLoanApplication = (loanAppId: string, itemsById: any) => (
  dispatch: Dispatch<any>
) => {
  dispatch(loanApplicationRequest(loanAppId));
  return dispatch(loanApplicationRequestSuccess({ id: loanAppId, itemsById }));
};

/**
 * Async
 */
export const requestLoanApplicationById: ThunkActionCreator<
  Promise<any>,
  any
> = (loanAppId: string) => (dispatch) => {
  dispatch(loanApplicationRequestStart());
  return getLoanAppplication(loanAppId)
    .then((response: any) => {
      dispatch(loanApplicationRequestSuccessById(response));
      return response;
    })
    .catch((err) => {
      dispatch(loanApplicationRequestFailById(err));
      return err;
    });
};



/**
 * updateLoanApplication update the loan by id
 */
export const updateLoanApplication: ThunkActionCreator<
  Promise<any>,
  any
> = (loanApp: any) => (dispatch) => {
  dispatch(loanApplicationRequestStart());
  const loanSpec = pathOr({}, ['spec'], loanApp)
  return updateLoanAppByID(loanApp)
    .then((response: any) => {
      dispatch(loanApplicationRequestSuccessById(set(lensPath(['spec']), loanSpec, response)));
      return response;
    })
    .catch((err) => {
      dispatch(loanApplicationRequestFailById(err));
      return err;
    });
};

export const updateSingleLoanAppInStore = (data: any) => (
  dispatch: Dispatch<any>
) => {
  dispatch(setLoanAppInStore(data));
};
